import React, {useState,useEffect,useRef} from 'react'
import { Formik, Field } from 'formik'
import { Table,Button,Icon,Form,Select,Input,List,Image,Label,TextArea,Message,Popup,Grid,Header } from 'semantic-ui-react'
import moment from 'moment'
import DatePicker from "react-datepicker"
import Cleave from 'cleave.js/react'
import {WindowReload, WindowURL, WindowLocation} from '../../config/settings'
import Alertmessage from '../../config/alert'
import axios from 'axios'
import renderHTML from 'react-render-html'
import {validateStep4_joint} from './validate'


export default function OpenAccountStep4Joints(props) {

	function CallbackFunction(data){
		props.active(data);
	}
	 function CallbackState(data){
		 props.callstate(data);
	 }


	/*-------------------------------------------------------------------------
	 Forms: Adding
	--------------------------------------------------------------------------*/
	const [datenow, setdatenow] = useState('month/day/year ('+moment(new Date()).format('MM/DD/YYYY')+')');
	const [state,setstate] = useState({
		reps_id:props.state.reps_id,
		first_name:props.state.first_name,
		middle_name:props.state.middle_name,
		last_name:props.state.last_name,
		date_birth_options:props.state.date_birth_options,
		date_birth:props.state.date_birth,
		date_birth_text:props.state.date_birth_text,
		citizenship:props.state.citizenship,
		citizen_country:props.state.citizen_country,
		type_id:props.state.type_id,
		id_number:props.state.id_number,
		address1:props.state.address1,
		address2:props.state.address2,
		city:props.state.city,
		state:props.state.state,
		country:props.state.country,
		postal_code:props.state.postal_code,
		primary_number:props.state.primary_number,
		home_number:props.state.home_number,
		cellular_number:props.state.cellular_number,
		fax:props.state.fax,
		email:props.state.email,
		marital_status:props.state.marital_status,
		no_dependents:props.state.no_dependents,

		joint_first_name:props.state.joint_first_name,
		joint_middle_name:props.state.joint_middle_name,
		joint_last_name:props.state.joint_last_name,
		joint_date_birth_options:props.state.joint_date_birth_options,
		joint_date_birth:props.state.joint_date_birth,
		joint_date_birth_text:props.state.joint_date_birth_text,
		joint_citizenship:props.state.joint_citizenship,
		joint_citizen_country:props.state.joint_citizen_country,
		joint_type_id:props.state.joint_type_id,
		joint_id_number:props.state.joint_id_number,
		joint_address1:props.state.joint_address1,
		joint_address2:props.state.joint_address2,
		joint_city:props.state.joint_city,
		joint_state:props.state.joint_state,
		joint_country:props.state.joint_country,
		joint_postal_code:props.state.joint_postal_code,
		joint_primary_number:props.state.joint_primary_number,
		joint_home_number:props.state.joint_home_number,
		joint_cellular_number:props.state.joint_cellular_number,
		joint_fax:props.state.joint_fax,
		joint_email:props.state.joint_email,
		joint_marital_status:props.state.joint_marital_status,
		joint_no_dependents:props.state.joint_no_dependents,

	});

	function handleSubmitForm(values, props){

		let value = {
			reps_id:values.reps_id,
			first_name:values.first_name,
			middle_name:values.middle_name,
			last_name:values.last_name,
			date_birth_options:values.date_birth_options,
			date_birth:(values.date_birth!=''&&values.date_birth_options==1)?moment(new Date(values.date_birth)).format('YYYY-MM-DD'):'',
			date_birth_text:values.date_birth_text,
			citizenship:values.citizenship,
			citizen_country:values.citizen_country,
			type_id:values.type_id,
			id_number:values.id_number,
			address1:values.address1,
			address2:values.address2,
			city:values.city,
			state:values.state,
			country:values.country,
			postal_code:values.postal_code,
			primary_number:values.primary_number,
			home_number:values.home_number,
			cellular_number:values.cellular_number,
			fax:values.fax,
			email:values.email,
			marital_status:values.marital_status,
			no_dependents:values.no_dependents,

			joint_first_name:values.joint_first_name,
			joint_middle_name:values.joint_middle_name,
			joint_last_name:values.joint_last_name,
			joint_date_birth_options:values.joint_date_birth_options,
			joint_date_birth:(values.joint_date_birth!=''&&values.joint_date_birth_options==1)?moment(new Date(values.joint_date_birth)).format('YYYY-MM-DD'):'',
			joint_date_birth_text:values.joint_date_birth_text,
			joint_citizenship:values.joint_citizenship,
			joint_citizen_country:values.joint_citizen_country,
			joint_type_id:values.joint_type_id,
			joint_id_number:values.joint_id_number,
			joint_address1:values.joint_address1,
			joint_address2:values.joint_address2,
			joint_city:values.joint_city,
			joint_state:values.joint_state,
			joint_country:values.joint_country,
			joint_postal_code:values.joint_postal_code,
			joint_primary_number:values.joint_primary_number,
			joint_home_number:values.joint_home_number,
			joint_cellular_number:values.joint_cellular_number,
			joint_fax:values.joint_fax,
			joint_email:values.joint_email,
			joint_marital_status:values.joint_marital_status,
			joint_no_dependents:values.joint_no_dependents,
		}


		 CallbackState(value);
		 CallbackFunction(5);



	}



	/*-------------------------------------
		Queries
	--------------------------------------*/
	const [repslist, setrepslist] = useState([]);
	const [countries, setcountries] = useState([]);
	const [seclist, setseclist] = useState([]);

	function ApplicationQuries(){
		let formData = new FormData();
		formData.append('type','query_application');
		axios.post('/application/http.php',formData)
		.then(function (response) {
				let obj = response.data;
				setrepslist(obj.reps);
				setcountries(obj.countries);
				setseclist(obj.seclist);
		})
		.catch(function (error){
		});
	}



	/*-------------------------------------
		Content
	--------------------------------------*/
	const [content, setcontent] = useState({
		form:{
			country: {
				title:'',
				content:'',
			}
		},
	});
	function ContentApplication(){
		let formData = new FormData();
		formData.append('type','content');
		axios.post('/content/request.php',formData)
		.then(function (response) {
				let obj = response.data;
				setcontent({
					...content,
					form:{
						country: {
							title:obj.form.country.title,
							content:obj.form.country.content,
						}
					},
				});
		})
		.catch(function (error){
		});
	}

	useEffect(()=>{
		ContentApplication();
		ApplicationQuries();
	},[]);


	return (
		<React.Fragment>
				<Form autocomplete="off">
					<Formik
					  enableReinitialize
						initialValues={state}
						validationSchema={validateStep4_joint}
						onSubmit={handleSubmitForm}
						render={formProps => {
						const { values, isSubmitting, errors, handleChange, handleBlur, handleSubmit, isValid, touched, setFieldValue } = formProps

						const CustomDateBirth = ({ value, onClick }) => (
  						<Input iconPosition='left' onClick={onClick} value={values.date_birth}><Icon name='calendar alternate' /><input /></Input>
  				  );
						const CustomDateBirthJoint = ({ value, onClick }) => (
  						<Input iconPosition='left' onClick={onClick} value={values.joint_date_birth}><Icon name='calendar alternate' /><input /></Input>
  				  );


						return(
			         <div className="open-account-panel">
                 <div className="open-account-panel-header">
                   <h2>Account Details</h2>
									 <p>Please fill out the following information to receive the necessary account application forms. You may choose to either download the form immediately, or request that a printed copy is mailed to you.</p>
                </div>
			            <div className="open-account-panel-body">

									<Form.Group widths="equal">
										<Field name="reps_id">
											{({ field, form }) => (
													<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
														<label>Representative</label>
														<Select selectOnBlur={false}
																{...field}
																options={repslist}
																onChange={(e, { value }) => setFieldValue(field.name,value)}/>
														{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
													</Form.Field>
											)}
										</Field>
									</Form.Group>

									<div className="account-body-wrapper">
									   <div>
											<div className="application-box">
											  <h3>Individual Account Information</h3>
												<Form.Group widths="equal">
													<Field name="first_name">
															{({ field, form }) => (
															<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																<label>First Name</label>
																<Input {...field} onChange={handleChange}/>
																{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															</Form.Field>
															)}
													</Field>
												</Form.Group>
												<Form.Group widths="equal">
													<Field name="middle_name">
															{({ field, form }) => (
															<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																<label>Middle Name</label>
																<Input {...field} onChange={handleChange}/>
																{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															</Form.Field>
															)}
													</Field>
												</Form.Group>
												<Form.Group widths="equal">
													<Field name="last_name">
															{({ field, form }) => (
															<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																<label>Last Name</label>
																<Input {...field} onChange={handleChange}/>
																{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															</Form.Field>
															)}
													</Field>
												</Form.Group>
												<Form.Group widths="equal">
													<Field name="date_birth_options">
														{({ field, form }) => (
																<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																	<label>Date of Birth Input Type</label>
																	<Select selectOnBlur={false}
																			{...field}
																			options={[
																					{ key: '0', text: 'Dropdown Input', value: '1' },
																					{ key: '1', text: 'Manual Input', value: '2' },
																			]}
																			onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																	{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																</Form.Field>
														)}
													</Field>
												</Form.Group>

												{values.date_birth_options==1&&<Form.Group widths="equal">
													<Field name="date_birth">
															{({ field, form }) => (
															<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																<label>Date of Birth</label>
																<DatePicker
																		showYearDropdown
																		yearDropdownItemNumber={100}
																		scrollableYearDropdown
																		showMonthDropdown
																		dropdownMode="select"
																		maxDate={new Date()}
	                                  selected={values.date_birth!=''?new Date(values.date_birth):null}
	                                  onChange={date => {
	                                     var date_selected 	= moment(new Date(date)).format('MM/DD/YYYY');
																			 setFieldValue(field.name,date_selected);
	                                  }}
	                                  customInput={<CustomDateBirth />}/>
																{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															</Form.Field>
															)}
													</Field>
												</Form.Group>}

												{values.date_birth_options==2&&<Form.Group widths="equal">
													<Field name="date_birth_text">
															{({ field, form }) => (
															<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																<label>Date of Birth</label>
																<Input {...field} onChange={handleChange} placeholder={datenow}/>
																{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															</Form.Field>
															)}
													</Field>
												</Form.Group>}

												<Form.Group widths="equal">
													<Field name="citizenship">
															{({ field, form }) => (
															<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																<label>Citizenship</label>
																<div className="input-chekbox-form">
																	 <span onClick={()=>{setFieldValue('citizenship',1);}}><Icon name={values.citizenship==1?'dot circle outline active':'circle outline'}/>U.K. Citizen</span>
																</div>
																<div className="input-chekbox-form">
																	 <span onClick={()=>{setFieldValue('citizenship',2);}}><Icon name={values.citizenship==2?'dot circle outline active':'circle outline'}/>Non - U.K. Citizen</span>
																</div>
																{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															</Form.Field>
															)}
													</Field>
												</Form.Group>

												{values.citizenship==2&&<Form.Group widths="equal">
													<Field name="citizen_country">
															{({ field, form }) => (
															<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																<label>Country</label>
																<Input {...field} onChange={handleChange}/>
																{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															</Form.Field>
															)}
													</Field>
												</Form.Group>}


												<Form.Group widths="equal">
													<Field name="type_id">
														{({ field, form }) => (
																<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																	<label>Type of ID</label>
																	<Select selectOnBlur={false}
																			{...field}
																			options={[
																					{ key: '0', text: 'Drivers License', value: '1' },
																					{ key: '1', text: 'Passport', value: '2' },
																					{ key: '2', text: 'Other government issued ID', value: '3' },
																			]}
																			onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																	{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																</Form.Field>
														)}
													</Field>
												</Form.Group>
												<Form.Group widths="equal">
													<Field name="id_number">
															{({ field, form }) => (
															<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																<label>ID Number</label>
																<Input {...field} onChange={handleChange}/>
																{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															</Form.Field>
															)}
													</Field>
												</Form.Group>
										 	</div>

											<div className="application-box">
												<h3>Mailing Address</h3>
												<Form.Group widths="equal">
												 <Field name="address1">
														 {({ field, form }) => (
														 <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															 <label>Address 1</label>
															 <Input {...field} onChange={handleChange}/>
															 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
														 </Form.Field>
														 )}
												 </Field>
											 </Form.Group>
											 <Form.Group widths="equal">
												<Field name="address2">
														{({ field, form }) => (
														<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															<label>Address 2</label>
															<Input {...field} onChange={handleChange}/>
															{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
														</Form.Field>
														)}
												</Field>
											</Form.Group>
												<Form.Group widths="equal">
												 <Field name="city">
														 {({ field, form }) => (
														 <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															 <label>City</label>
															 <Input {...field} onChange={handleChange}/>
															 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
														 </Form.Field>
														 )}
												 </Field>
											 </Form.Group>
											 <Form.Group widths="equal">
												<Field name="state">
														{({ field, form }) => (
														<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															<label>State</label>
															<Input {...field} onChange={handleChange}/>
															{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
														</Form.Field>
														)}
												</Field>
											</Form.Group>
											<Form.Group widths="equal">
												<Field name="country">
													{({ field, form }) => (
															<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																<label>Country <Popup trigger={<span className="infofields">(What's this?)</span>} position='top left'>
															    <Grid centered divided columns={1}>
															      <Grid.Column>
																				<Header as='h4'>{content.form.country.title}</Header>
																				<p>{content.form.country.content}</p>
															      </Grid.Column>
															    </Grid>
															  </Popup></label>
																<Select selectOnBlur={false}
																		{...field}
																		options={countries}
																		onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															</Form.Field>
													)}
												</Field>
											</Form.Group>
											<Form.Group widths="equal">
											 <Field name="postal_code">
													 {({ field, form }) => (
													 <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
														 <label>Postal Code</label>
														 <Input {...field} onChange={handleChange}/>
														 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
													 </Form.Field>
													 )}
											 </Field>
										 </Form.Group>
											</div>

											<div className="application-box">
												<h3>Contact Information</h3>
														<Form.Group widths="equal">
														 <Field name="primary_number">
																 {({ field, form }) => (
																 <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																	 <label>Primary/Daytime Phone Number</label>
																	 <Cleave {...field} options={{numericOnly: true}} onChange={handleChange} maxLength="16"/>
																	 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																 </Form.Field>
																 )}
														 </Field>
													 </Form.Group>
													 <Form.Group widths="equal">
														<Field name="home_number">
																{({ field, form }) => (
																<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																	<label>Home/Evening Phone</label>
																	<Cleave {...field} options={{numericOnly: true}} onChange={handleChange} maxLength="16"/>
																	{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																</Form.Field>
																)}
														</Field>
													</Form.Group>
													<Form.Group widths="equal">
													 <Field name="cellular_number">
															 {({ field, form }) => (
															 <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																 <label>Cellular/Portable Phone</label>
																 <Cleave {...field} options={{numericOnly: true}} onChange={handleChange} maxLength="16"/>
																 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															 </Form.Field>
															 )}
													 </Field>
												 </Form.Group>
												 <Form.Group widths="equal">
													<Field name="fax">
															{({ field, form }) => (
															<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																<label>Fax</label>
																<Cleave {...field} options={{numericOnly: true}} onChange={handleChange} maxLength="16"/>
																{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															</Form.Field>
															)}
													</Field>
												</Form.Group>
												<Form.Group widths="equal">
												 <Field name="email">
														 {({ field, form }) => (
														 <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															 <label>Email</label>
															 <Input {...field} onChange={handleChange}/>
															 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
														 </Form.Field>
														 )}
												 </Field>
											 </Form.Group>
											</div>

											<div className="application-box">
												 <h3>Marital Status</h3>
													<Form.Group widths="equal">
													 <Field name="marital_status">
															 {({ field, form }) => (
															 <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																 <div className="input-chekbox-form">
																		<span onClick={()=>{setFieldValue('marital_status',1);}}><Icon name={values.marital_status==1?'dot circle outline active':'circle outline'}/>Single</span>
																 </div>
																 <div className="input-chekbox-form">
																		<span onClick={()=>{setFieldValue('marital_status',2);}}><Icon name={values.marital_status==2?'dot circle outline active':'circle outline'}/>Married</span>
																 </div>
																 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															 </Form.Field>
															 )}
													 </Field>
												 </Form.Group>
												 <Form.Group widths="equal">
												 <Field name="no_dependents">
														 {({ field, form }) => (
														 <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															 <label>No of Dependents</label>
															 <Cleave {...field} options={{numericOnly: true}} onChange={handleChange} maxLength="16"/>
															 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
														 </Form.Field>
														 )}
												 </Field>
											 </Form.Group>
											 </div>


										 </div>{/*.left column*/}



                     {/* -------------------------------------------------------------------------
											 JOINT ACCOUNT INFORMATION
											--------------------------------------------------------------------------*/}
										 <div>
										 	<div className="application-box">
											 <h3>Joint Account Information</h3>
											 <Form.Group widths="equal">
												 <Field name="joint_first_name">
														 {({ field, form }) => (
														 <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															 <label>First Name</label>
															 <Input {...field} onChange={handleChange}/>
															 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
														 </Form.Field>
														 )}
												 </Field>
											 </Form.Group>
											 <Form.Group widths="equal">
												 <Field name="joint_middle_name">
														 {({ field, form }) => (
														 <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															 <label>Middle Name</label>
															 <Input {...field} onChange={handleChange}/>
															 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
														 </Form.Field>
														 )}
												 </Field>
											 </Form.Group>
											 <Form.Group widths="equal">
												 <Field name="joint_last_name">
														 {({ field, form }) => (
														 <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															 <label>Last Name</label>
															 <Input {...field} onChange={handleChange}/>
															 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
														 </Form.Field>
														 )}
												 </Field>
											 </Form.Group>
											 <Form.Group widths="equal">
												 <Field name="joint_date_birth_options">
													 {({ field, form }) => (
															 <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																 <label>Date of Birth Input Type</label>
																 <Select selectOnBlur={false}
																		 {...field}
																		 options={[
																				 { key: '0', text: 'Dropdown Input', value: '1' },
																				 { key: '1', text: 'Manual Input', value: '2' },
																		 ]}
																		 onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															 </Form.Field>
													 )}
												 </Field>
											 </Form.Group>

											 {values.joint_date_birth_options==1&&<Form.Group widths="equal">
												 <Field name="joint_date_birth">
														 {({ field, form }) => (
														 <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															 <label>Date of Birth</label>
															 <DatePicker
																	 showYearDropdown
																	 yearDropdownItemNumber={100}
																	 scrollableYearDropdown
																	 showMonthDropdown
																	 dropdownMode="select"
																	 maxDate={new Date()}
																	 selected={values.joint_date_birth!=''?new Date(values.joint_date_birth):''}
																	 onChange={date => {
																			var date_selected 	= moment(new Date(date)).format('MM/DD/YYYY');
																			setFieldValue(field.name,date_selected);
																	 }}
																	 customInput={<CustomDateBirthJoint />}/>
															 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
														 </Form.Field>
														 )}
												 </Field>
											 </Form.Group>}

											 {values.joint_date_birth_options==2&&<Form.Group widths="equal">
												 <Field name="joint_date_birth_text">
														 {({ field, form }) => (
														 <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															 <label>Date of Birth</label>
															 <Input {...field} onChange={handleChange} placeholder={datenow}/>
															 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
														 </Form.Field>
														 )}
												 </Field>
											 </Form.Group>}

											 <Form.Group widths="equal">
												 <Field name="joint_citizenship">
														 {({ field, form }) => (
														 <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															 <label>Citizenship</label>
															 <div className="input-chekbox-form">
																	<span onClick={()=>{setFieldValue('joint_citizenship',1);}}><Icon name={values.joint_citizenship==1?'dot circle outline active':'circle outline'}/>U.K. Citizen</span>
															 </div>
															 <div className="input-chekbox-form">
																	<span onClick={()=>{setFieldValue('joint_citizenship',2);}}><Icon name={values.joint_citizenship==2?'dot circle outline active':'circle outline'}/>Non - U.K. Citizen</span>
															 </div>
															 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
														 </Form.Field>
														 )}
												 </Field>
											 </Form.Group>

											 {values.joint_citizenship==2&&<Form.Group widths="equal">
												 <Field name="joint_citizen_country">
														 {({ field, form }) => (
														 <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															 <label>Country</label>
															 <Input {...field} onChange={handleChange}/>
															 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
														 </Form.Field>
														 )}
												 </Field>
											 </Form.Group>}


											 <Form.Group widths="equal">
												 <Field name="joint_type_id">
													 {({ field, form }) => (
															 <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																 <label>Type of ID</label>
																 <Select selectOnBlur={false}
																		 {...field}
																		 options={[
																				 { key: '0', text: 'Drivers License', value: '1' },
																				 { key: '1', text: 'Passport', value: '2' },
																				 { key: '2', text: 'Other government issued ID', value: '3' },
																		 ]}
																		 onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															 </Form.Field>
													 )}
												 </Field>
											 </Form.Group>
											 <Form.Group widths="equal">
												 <Field name="joint_id_number">
														 {({ field, form }) => (
														 <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															 <label>ID Number</label>
															 <Input {...field} onChange={handleChange}/>
															 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
														 </Form.Field>
														 )}
												 </Field>
											 </Form.Group>
										 </div>

										 <div className="application-box">
											 <h3>Mailing Address</h3>
											 <Form.Group widths="equal">
												<Field name="joint_address1">
														{({ field, form }) => (
														<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															<label>Address 1</label>
															<Input {...field} onChange={handleChange}/>
															{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
														</Form.Field>
														)}
												</Field>
											</Form.Group>
											<Form.Group widths="equal">
											 <Field name="joint_address2">
													 {({ field, form }) => (
													 <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
														 <label>Address 2</label>
														 <Input {...field} onChange={handleChange}/>
														 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
													 </Form.Field>
													 )}
											 </Field>
										 </Form.Group>
											 <Form.Group widths="equal">
												<Field name="joint_city">
														{({ field, form }) => (
														<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															<label>City</label>
															<Input {...field} onChange={handleChange}/>
															{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
														</Form.Field>
														)}
												</Field>
											</Form.Group>
											<Form.Group widths="equal">
											 <Field name="joint_state">
													 {({ field, form }) => (
													 <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
														 <label>State</label>
														 <Input {...field} onChange={handleChange}/>
														 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
													 </Form.Field>
													 )}
											 </Field>
										 </Form.Group>
										 <Form.Group widths="equal">
											 <Field name="joint_country">
												 {({ field, form }) => (
														 <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															 <label>Country <Popup trigger={<span className="infofields">(What's this?)</span>} position='top left'>
																 <Grid centered divided columns={1}>
																	 <Grid.Column>
																		 <Header as='h4'>{content.form.country.title}</Header>
																		 <p>{content.form.country.content}</p>
																	 </Grid.Column>
																 </Grid>
															 </Popup></label>
															 <Select selectOnBlur={false}
																	 {...field}
																	 options={countries}
																	 onChange={(e, { value }) => setFieldValue(field.name,value)}/>
															 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
														 </Form.Field>
												 )}
											 </Field>
										 </Form.Group>
										 <Form.Group widths="equal">
											<Field name="joint_postal_code">
													{({ field, form }) => (
													<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
														<label>Postal Code</label>
														<Input {...field} onChange={handleChange}/>
														{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
													</Form.Field>
													)}
											</Field>
										</Form.Group>
										 </div>

										 <div className="application-box">
											 <h3>Contact Information</h3>
													 <Form.Group widths="equal">
														<Field name="joint_primary_number">
																{({ field, form }) => (
																<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																	<label>Primary/Daytime Phone Number</label>
																	<Cleave {...field} options={{numericOnly: true}} onChange={handleChange} maxLength="16"/>
																	{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																</Form.Field>
																)}
														</Field>
													</Form.Group>
													<Form.Group widths="equal">
													 <Field name="joint_home_number">
															 {({ field, form }) => (
															 <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																 <label>Home/Evening Phone</label>
																 <Cleave {...field} options={{numericOnly: true}} onChange={handleChange} maxLength="16"/>
																 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															 </Form.Field>
															 )}
													 </Field>
												 </Form.Group>
												 <Form.Group widths="equal">
													<Field name="joint_cellular_number">
															{({ field, form }) => (
															<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																<label>Cellular/Portable Phone</label>
																<Cleave {...field} options={{numericOnly: true}} onChange={handleChange} maxLength="16"/>
																{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															</Form.Field>
															)}
													</Field>
												</Form.Group>
												<Form.Group widths="equal">
												 <Field name="joint_fax">
														 {({ field, form }) => (
														 <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															 <label>Fax</label>
															 <Cleave {...field} options={{numericOnly: true}} onChange={handleChange} maxLength="16"/>
															 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
														 </Form.Field>
														 )}
												 </Field>
											 </Form.Group>
											 <Form.Group widths="equal">
												<Field name="joint_email">
														{({ field, form }) => (
														<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															<label>Email</label>
															<Input {...field} onChange={handleChange}/>
															{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
														</Form.Field>
														)}
												</Field>
											</Form.Group>
										 </div>

										 <div className="application-box">
												<h3>Marital Status</h3>
												 <Form.Group widths="equal">
													<Field name="joint_marital_status">
															{({ field, form }) => (
															<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																<div className="input-chekbox-form">
																	 <span onClick={()=>{setFieldValue('joint_marital_status',1);}}><Icon name={values.joint_marital_status==1?'dot circle outline active':'circle outline'}/>Single</span>
																</div>
																<div className="input-chekbox-form">
																	 <span onClick={()=>{setFieldValue('joint_marital_status',2);}}><Icon name={values.joint_marital_status==2?'dot circle outline active':'circle outline'}/>Married</span>
																</div>
																{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															</Form.Field>
															)}
													</Field>
												</Form.Group>
												<Form.Group widths="equal">
												<Field name="joint_no_dependents">
														{({ field, form }) => (
														<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															<label>No of Dependents</label>
															<Cleave {...field} options={{numericOnly: true}} onChange={handleChange} maxLength="16"/>
															{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
														</Form.Field>
														)}
												</Field>
											</Form.Group>
											</div>
										 </div>{/*.right column*/}



									</div>{/*.account-body-wrapper*/}
									</div>{/*.panel-body*/}
			            <div className="open-account-panel-footer">
									    <div className="account-panel-footer">
									    	<div><Button content='Back' className="primary" icon='left arrow' labelPosition='left' onClick={()=>CallbackFunction(3)}/></div>
                      	<div><Button content='Continue' className="primary" icon='right arrow' labelPosition='right' onClick={handleSubmit}/></div>
											</div>
									</div>
			         </div>

						 )}}/>
					</Form>
    </React.Fragment>
  )
}
